import { Link, useLocation } from "react-router-dom";
import Icon from "../AppIcon";

const navigationLinks = [
  { name: "Home", path: "/homepage-cinematic-gateway", icon: "HomeIcon" },
  { name: "About", path: "/studio-universe-about", icon: "UsersIcon" },
  { name: "Portfolio", path: "/cinematic-showcase-portfolio", icon: "FilmIcon" },
  { name: "Services", path: "/corporate-solutions-services", icon: "BriefcaseIcon" },
];

const serviceLinks = [
  { label: "Brand Strategy", path: "/corporate-solutions-services#brand-strategy" },
  { label: "Creative Design", path: "/corporate-solutions-services#creative-design" },
  { label: "Digital Marketing", path: "/corporate-solutions-services#digital-marketing" },
  { label: "Content Production", path: "/corporate-solutions-services#content-production" },
];

const socialLinks = [
  { name: "LinkedIn", icon: "Linkedin", href: "#" },
  { name: "Twitter", icon: "Twitter", href: "#" },
  { name: "Instagram", icon: "Instagram", href: "#" },
  { name: "Facebook", icon: "Facebook", href: "#" },
];

const Footer = ({ className = "" }) => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();

  return (
    <footer data-theme="dark" className={`bg-black text-white ${className}`}>
      <div className="container mx-auto px-4 py-8 sm:py-16">
        {/* TOP GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12 items-start">
          {/* LOGO / BRAND */}
          <div className="space-y-4">
            <Link to="/homepage-cinematic-gateway" className="flex items-center">
              <div className="w-20 h-20 md:w-24 md:h-24 overflow-hidden rounded-lg">
                <img
                  src="/assets/images/logo/2.png"
                  alt="HYPE Logo"
                  className="w-full h-full object-contain object-center"
                />
              </div>
            </Link>

            <p className="text-sm text-gray-400 leading-relaxed">
              Bold creative work that drives measurable business results. African excellence meets global ambition.
            </p>

            <div className="flex items-center space-x-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  aria-label={social.name}
                  className="p-2 bg-gray-800 hover:bg-primary rounded-lg transition"
                >
                  <Icon name={social.icon} size={20} />
                </a>
              ))}
            </div>
          </div>

          {/* NAVIGATION + SERVICES */}
          <div className="grid grid-cols-2 gap-6">
            {/* NAVIGATION */}
            <div>
              <h3 className="text-lg font-bold text-white mb-2">Navigation</h3>
              <ul className="flex flex-col gap-3">
                {navigationLinks.map((item) => {
                  const isActive = location.pathname === item.path;
                  return (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        className={`flex items-center gap-2 text-sm transition-colors ${
                          isActive ? "text-red-600" : "text-gray-400 hover:text-red-600"
                        }`}
                      >
                        <Icon name={item.icon} size={16} />
                        {item.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* SERVICES */}
            <div>
              <h3 className="text-lg font-bold text-white mb-2">Services</h3>
              <ul className="flex flex-col gap-3">
                {serviceLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-gray-400 hover:text-red-600 transition"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* CTA / CONTACT */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-white mb-2">Get Started</h3>
            <p className="text-sm text-gray-400">
              Ready to transform your brand? Let’s build something extraordinary.
            </p>

            <Link
              to="/booking-concierge-premium-consultation"
              className="inline-block px-6 py-3 bg-red-600 text-white font-bold text-sm rounded-lg hover:opacity-70 transition"
            >
              Book Strategy Session
            </Link>

            <div className="flex flex-col gap-2 pt-2">
              <a
                href="mailto:info@hype.co.ke"
                className="flex items-center text-sm text-gray-400 hover:text-red-600"
              >
                <Icon name="Mail" size={18} className="mr-2" />
                info@hype.co.ke
              </a>
              <a
                href="tel:+254740000444"
                className="flex items-center text-sm text-gray-400 hover:text-red-600"
              >
                <Icon name="PhoneIcon" size={18} className="mr-2" />
                +254 (740) 000 444
              </a>
            </div>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500 text-center md:text-left">
            © {currentYear} Hype Your Products and Events.
            <span className="block md:inline md:ml-1">All rights reserved.</span>
          </p>

          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-red-600">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-gray-500 hover:text-red-600">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
